<mat-expansion-panel #panel class="expansion-panel-review" hideToggle >
    <mat-expansion-panel-header>
        <div class="field-name">
            <div class="card-title">
                {{ 'POSITION.SZILUETT_POSITION_PROFILE' | translate }}
            </div>
        </div>
        <div class="card-actions">
            <button mat-flat-button color="primary" class="review-button bt-long-text">
                <mat-icon *ngIf="!panel.expanded" >keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="panel.expanded">keyboard_arrow_up</mat-icon>
                {{ 'POSITION.DETAILS' | translate }}
            </button>
        </div>
    </mat-expansion-panel-header>
    <div *ngIf="items$ | async as categories" class="card-content">

        
        <div *ngFor="let category of categories; let i = index" class="cat-item">
            
            <div class="title-row">
                <div class="category-name"><strong>{{ category.name }}</strong></div>
                <div class="key-factor-header">{{ 'POSITION.KEY_FACTOR' | translate }}</div>
            </div>
            <app-position-profile-item 
                *ngFor="let item of category.profiles; let i = index" 
                [data]="item" 
                [position]="position"
                (validityChange)="updateValidity(i, $event)">
                </app-position-profile-item>
        </div>
    </div>
</mat-expansion-panel>
